const sleepHours = ["Menos de 4", "5-6", "7-8", "9 o más"];
export default sleepHours;
